/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Lot_Debt_Warning_IntroInputs */

const vi_pos_lot_debt_warning_intro = /** @type {(inputs: Pos_Lot_Debt_Warning_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho đang thiếu. Bán nợ lô thì khách nhận hàng ngay, kho nhập bù sau:`)
};

/**

* @param {Pos_Lot_Debt_Warning_IntroInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_lot_debt_warning_intro = /** @type {((inputs?: Pos_Lot_Debt_Warning_IntroInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Lot_Debt_Warning_IntroInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_lot_debt_warning_intro(inputs)
});